import { HttpInterceptorFn } from '@angular/common/http';
/**
 * HTTP Interceptor that adds a device ID to all HTTP requests
 * Uses ClientJS to generate a unique device fingerprint
 * Skips adding device ID for config.json requests
 */
export const deviceIdInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip adding device ID for config.json requests
  if (req.url.includes('config.json')) {
    return next(req);
  }

  // Get device ID from localStorage or generate a new one
  let deviceId = localStorage.getItem('x-device-id');

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem('x-device-id', deviceId);
  }

  // Add device ID header to request
  const modifiedReq = req.clone({
    setHeaders: {
      'x-device-id': deviceId,
    },
  });

  return next(modifiedReq);
};
